import { z } from 'zod';

const instant = z.string().datetime({ offset: true });
const slot = z.object({ start: instant, end: instant }).refine(
  value => new Date(value.end).getTime() > new Date(value.start).getTime(),
  { message: 'end deve essere successivo a start', path: ['end'] },
);
const eligibilityBase = z.object({
  service_id: z.string().uuid(),
  product_id: z.string().uuid().nullish(),
  store_id: z.string().uuid().nullish(),
  candidate_user_ids: z.array(z.string().uuid()).nullish(),
  prefer_user_id: z.string().uuid().nullish(),
  overrides: z.object({
    force_outside_shift: z.boolean().optional(),
    force_without_clockin: z.boolean().optional(),
    force_missing_skills: z.boolean().optional(),
  }).nullish(),
});
export const calendarEligibleResourcesInputSchema = eligibilityBase.extend({
  start: instant, end: instant,
}).refine(value => new Date(value.end).getTime() > new Date(value.start).getTime(), {
  message: 'end deve essere successivo a start', path: ['end'],
});
export const calendarEligibleResourcesPerSlotInputSchema = eligibilityBase.extend({
  slots: z.array(slot).min(1),
});
